import { Component } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { EditDialogInstance } from '../editDialog/editDialogService';
import { CommandTemplate } from '../../entities/commandTemplate/commandTemplate';
import { EditDialogComponent } from '../editDialog/editDialogComponent';

import { LabelInput } from '../../entities/label/labelInput';
import { Apollo } from 'apollo-angular';
import * as fromGraphQl from './graphql';
import { debounceTime, distinctUntilChanged, first, map, switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "app-create-dialog",
  templateUrl: "label-dialog.html"
})
export class LabelDialogComponent implements EditDialogInstance {

  public labelFormGroup: FormGroup;
  commandTemplate: CommandTemplate
  labelId: string | undefined;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public apollo: Apollo,
  ) {
    this.commandTemplate = this.config?.data.commandTemplate;
    this.initForm();
    this.labelId = this.commandTemplate?.getCommandProviderId();
    if(this.labelId) {
      this.loadLabel(this.labelId);
    }
  }

  initForm() {
    this.labelFormGroup = new FormGroup({});
    this.labelFormGroup.addControl('externalId', new FormControl( undefined, []));
    this.labelFormGroup.addControl('scopedName', new FormControl( undefined, [ Validators.required ],
      [this.scopedNameAvailableValidator()]));
    this.labelFormGroup.addControl('description', new FormControl(undefined,[ ]));
    this.labelFormGroup.addControl('color', new FormControl( '#2196f3', [ Validators.required, this.hexColorValidator() ]));
  }

  onConfirm(editDialogComponent: EditDialogComponent<any>): void {
    let labelInput = new LabelInput();
    labelInput.externalId = this.labelFormGroup.get('externalId')?.value;
    labelInput.scopedName = this.labelFormGroup.get('scopedName')?.value;
    labelInput.color = this.labelFormGroup.get('color')?.value;
    labelInput.description =  this.labelFormGroup.get('description')?.value;
    this.ref.close(labelInput);
  }

  onReject(editDialogComponent: EditDialogComponent<any>): void {
    this.ref.close(false);
  }

  getEditForm(): FormGroup {
    return this.labelFormGroup;
  }

  loadLabel(id: string): void {
    this.apollo.query<fromGraphQl.LabelDialogQueryResponse>({
      query: fromGraphQl.LABEL_DIALOG_QUERY,
      variables: {
        id: id
      },
      fetchPolicy: 'network-only',
    })
    .pipe(take(1))
    .subscribe(data => {
      this.labelFormGroup.patchValue(data?.data.label);
    });
  }

  scopedNameAvailableValidator(): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const labelInput = new LabelInput();
      labelInput.scopedName = control.value;
      if(this.labelId) {
        labelInput.id = this.labelId;
      }
      console.log('Validating scopedName: ' + control.value + ' for labelId: ' + this.labelId);
      return of(control.value).pipe(
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(value =>
          this.apollo.query<any>({
            query: fromGraphQl.IS_SCOPED_NAME_AVAILABLE_QUERY, // replace with real query
            variables: { input: labelInput }
          }).pipe(
            map(result => result?.data?.isAvailable ? null : { scopedNameTaken: true }),
            first()
          )
        )
      );
    };
  }

  hexColorValidator(): import('@angular/forms').ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      const valid = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(value);
      return valid ? null : { invalidHexColor: true };
    };
  }
}
